// extracted by mini-css-extract-plugin
export default {"question":"index_question_toT2X","submit_btn":"index_submit_btn_5A4EK"};